__turbopack_context__.v({
  "breakdownCard": "MortgageResults-module-scss-module__mNvOBa__breakdownCard",
  "breakdownGrid": "MortgageResults-module-scss-module__mNvOBa__breakdownGrid",
  "breakdownLabel": "MortgageResults-module-scss-module__mNvOBa__breakdownLabel",
  "breakdownValue": "MortgageResults-module-scss-module__mNvOBa__breakdownValue",
  "component": "MortgageResults-module-scss-module__mNvOBa__component",
  "destructive": "MortgageResults-module-scss-module__mNvOBa__destructive",
  "paymentAmount": "MortgageResults-module-scss-module__mNvOBa__paymentAmount",
  "paymentCard": "MortgageResults-module-scss-module__mNvOBa__paymentCard",
  "paymentHeader": "MortgageResults-module-scss-module__mNvOBa__paymentHeader",
  "paymentSubtext": "MortgageResults-module-scss-module__mNvOBa__paymentSubtext",
  "paymentTitle": "MortgageResults-module-scss-module__mNvOBa__paymentTitle",
  "stressTestAmount": "MortgageResults-module-scss-module__mNvOBa__stressTestAmount",
  "stressTestCard": "MortgageResults-module-scss-module__mNvOBa__stressTestCard",
  "stressTestContent": "MortgageResults-module-scss-module__mNvOBa__stressTestContent",
  "stressTestDescription": "MortgageResults-module-scss-module__mNvOBa__stressTestDescription",
  "stressTestHeader": "MortgageResults-module-scss-module__mNvOBa__stressTestHeader",
  "stressTestIcon": "MortgageResults-module-scss-module__mNvOBa__stressTestIcon",
  "stressTestTitle": "MortgageResults-module-scss-module__mNvOBa__stressTestTitle",
  "totalPaymentAmount": "MortgageResults-module-scss-module__mNvOBa__totalPaymentAmount",
  "totalPaymentCard": "MortgageResults-module-scss-module__mNvOBa__totalPaymentCard",
});
